import React from 'react'
import withView from '../../../cmn/docAutomation/withView';
import FormDialog from '../../../../library/form/components/FormDialog';
import FormTitle from '../../../../library/form/components/FormTitle'
import BudgetCmnHeaderEditor from "./BudgetCmnHeaderEditor";

const BudgetSH = (props) => {
    const { formObject, viewData, ...restProps } = props;

    return (
        <FormDialog onDynamicViewClose={restProps.onDynamicViewClose} enablePopup={true}
            action={{ formActions: { forAction: "Confirm", forCancel: "Cancel" }, actionParam: { showModeID: 'sh' } }}
            formStyle={{ width: '670px', height: '650px' }}
            contentStyle={{ height: '380px' }}
            formTitle={<FormTitle formObject={formObject} value='Main Detail' />}
            formObject={formObject} >
            <BudgetCmnHeaderEditor formObject={formObject} viewData={viewData} {...restProps} />
        </FormDialog>
    )
}

export default withView(BudgetSH, "budgetComp", "")